import { Step } from '../components/StepTracker';

// Authentication Flow Steps
export const authenticationSteps: Step[] = [
  // User Actions
  { id: 'auth-1', number: 1, description: 'User opens application', category: 'user', status: 'pending' },
  { id: 'auth-2', number: 2, description: 'User sees login form', category: 'frontend', status: 'pending' },
  { id: 'auth-3', number: 3, description: 'User enters email address', category: 'user', status: 'pending' },
  { id: 'auth-4', number: 4, description: 'User enters password', category: 'user', status: 'pending' },
  { id: 'auth-5', number: 5, description: 'User clicks Login button', category: 'user', status: 'pending' },
  
  // Frontend Processing
  { id: 'auth-6', number: 6, description: 'Validate email format', category: 'frontend', status: 'pending' },
  { id: 'auth-7', number: 7, description: 'Validate password length', category: 'frontend', status: 'pending' },
  { id: 'auth-8', number: 8, description: 'Show loading state', category: 'frontend', status: 'pending' },
  { id: 'auth-9', number: 9, description: 'Prepare login request', category: 'frontend', status: 'pending' },
  
  // Network
  { id: 'auth-10', number: 10, description: 'Send POST to /api/login', category: 'network', status: 'pending' },
  { id: 'auth-11', number: 11, description: 'Request reaches Cloudflare edge', category: 'network', status: 'pending' },
  { id: 'auth-12', number: 12, description: 'Route to API Worker', category: 'backend', status: 'pending' },
  
  // Backend Processing
  { id: 'auth-13', number: 13, description: 'Parse request body', category: 'backend', status: 'pending' },
  { id: 'auth-14', number: 14, description: 'Validate request data', category: 'backend', status: 'pending' },
  { id: 'auth-15', number: 15, description: 'Query D1 for user', category: 'database', status: 'pending' },
  { id: 'auth-16', number: 16, description: 'Retrieve user record', category: 'database', status: 'pending' },
  { id: 'auth-17', number: 17, description: 'Compare password hash', category: 'backend', status: 'pending' },
  { id: 'auth-18', number: 18, description: 'Generate JWT token', category: 'backend', status: 'pending' },
  { id: 'auth-19', number: 19, description: 'Sign token with secret', category: 'backend', status: 'pending' },
  
  // Response
  { id: 'auth-20', number: 20, description: 'Send success response', category: 'response', status: 'pending' },
  { id: 'auth-21', number: 21, description: 'Response travels to client', category: 'network', status: 'pending' },
  { id: 'auth-22', number: 22, description: 'Parse response JSON', category: 'frontend', status: 'pending' },
  { id: 'auth-23', number: 23, description: 'Store JWT in localStorage', category: 'frontend', status: 'pending' },
  { id: 'auth-24', number: 24, description: 'Update auth context', category: 'frontend', status: 'pending' },
  { id: 'auth-25', number: 25, description: 'Navigate to dashboard', category: 'frontend', status: 'pending' },
];

// User CRUD Operations Steps
export const userCrudSteps: Step[] = [
  // Create User
  { id: 'crud-1', number: 1, description: 'Open user form', category: 'user', status: 'pending' },
  { id: 'crud-2', number: 2, description: 'Enter user details', category: 'user', status: 'pending' },
  { id: 'crud-3', number: 3, description: 'Validate form data', category: 'frontend', status: 'pending' },
  { id: 'crud-4', number: 4, description: 'Send POST /api/users', category: 'network', status: 'pending' },
  { id: 'crud-5', number: 5, description: 'Insert into D1 database', category: 'database', status: 'pending' },
  { id: 'crud-6', number: 6, description: 'Return new user data', category: 'response', status: 'pending' },
  
  // Read Users
  { id: 'crud-7', number: 7, description: 'Component mounts', category: 'frontend', status: 'pending' },
  { id: 'crud-8', number: 8, description: 'Send GET /api/users', category: 'network', status: 'pending' },
  { id: 'crud-9', number: 9, description: 'Query all users from D1', category: 'database', status: 'pending' },
  { id: 'crud-10', number: 10, description: 'Return user list', category: 'response', status: 'pending' },
  { id: 'crud-11', number: 11, description: 'Render user table', category: 'frontend', status: 'pending' },
  
  // Update User
  { id: 'crud-12', number: 12, description: 'Click edit button', category: 'user', status: 'pending' },
  { id: 'crud-13', number: 13, description: 'Load user in form', category: 'frontend', status: 'pending' },
  { id: 'crud-14', number: 14, description: 'Modify user data', category: 'user', status: 'pending' },
  { id: 'crud-15', number: 15, description: 'Send PUT /api/users/:id', category: 'network', status: 'pending' },
  { id: 'crud-16', number: 16, description: 'Update D1 record', category: 'database', status: 'pending' },
  { id: 'crud-17', number: 17, description: 'Return updated data', category: 'response', status: 'pending' },
  
  // Delete User
  { id: 'crud-18', number: 18, description: 'Click delete button', category: 'user', status: 'pending' },
  { id: 'crud-19', number: 19, description: 'Confirm deletion', category: 'frontend', status: 'pending' },
  { id: 'crud-20', number: 20, description: 'Send DELETE /api/users/:id', category: 'network', status: 'pending' },
  { id: 'crud-21', number: 21, description: 'Delete from D1', category: 'database', status: 'pending' },
  { id: 'crud-22', number: 22, description: 'Return success', category: 'response', status: 'pending' },
  { id: 'crud-23', number: 23, description: 'Remove from UI', category: 'frontend', status: 'pending' },
];

// Project Management Steps
export const projectManagementSteps: Step[] = [
  // Create Project
  { id: 'proj-1', number: 1, description: 'Click New Project', category: 'user', status: 'pending' },
  { id: 'proj-2', number: 2, description: 'Enter project name', category: 'user', status: 'pending' },
  { id: 'proj-3', number: 3, description: 'Select project type', category: 'user', status: 'pending' },
  { id: 'proj-4', number: 4, description: 'Configure AI settings', category: 'user', status: 'pending' },
  { id: 'proj-5', number: 5, description: 'Validate configuration', category: 'frontend', status: 'pending' },
  { id: 'proj-6', number: 6, description: 'Send POST /api/projects', category: 'network', status: 'pending' },
  { id: 'proj-7', number: 7, description: 'Verify auth token', category: 'backend', status: 'pending' },
  { id: 'proj-8', number: 8, description: 'Store in D1 database', category: 'database', status: 'pending' },
  { id: 'proj-9', number: 9, description: 'Generate project ID', category: 'backend', status: 'pending' },
  { id: 'proj-10', number: 10, description: 'Return project data', category: 'response', status: 'pending' },
  { id: 'proj-11', number: 11, description: 'Update project list', category: 'frontend', status: 'pending' },
  
  // Project Settings
  { id: 'proj-12', number: 12, description: 'Open project settings', category: 'user', status: 'pending' },
  { id: 'proj-13', number: 13, description: 'Load current config', category: 'frontend', status: 'pending' },
  { id: 'proj-14', number: 14, description: 'Modify settings', category: 'user', status: 'pending' },
  { id: 'proj-15', number: 15, description: 'Save configuration', category: 'frontend', status: 'pending' },
  { id: 'proj-16', number: 16, description: 'Update in database', category: 'database', status: 'pending' },
];

// Complete Feature Deployment Steps
export const deploymentSteps: Step[] = [
  // Pre-deployment
  { id: 'deploy-1', number: 1, description: 'Run git status', category: 'frontend', status: 'pending' },
  { id: 'deploy-2', number: 2, description: 'Check for uncommitted changes', category: 'frontend', status: 'pending' },
  { id: 'deploy-3', number: 3, description: 'Run linting checks', category: 'frontend', status: 'pending' },
  { id: 'deploy-4', number: 4, description: 'Run type checking', category: 'frontend', status: 'pending' },
  { id: 'deploy-5', number: 5, description: 'Run unit tests', category: 'frontend', status: 'pending' },
  
  // Build Process
  { id: 'deploy-6', number: 6, description: 'Build React application', category: 'frontend', status: 'pending' },
  { id: 'deploy-7', number: 7, description: 'Optimize bundles', category: 'frontend', status: 'pending' },
  { id: 'deploy-8', number: 8, description: 'Build API Worker', category: 'backend', status: 'pending' },
  { id: 'deploy-9', number: 9, description: 'Build Files Worker', category: 'backend', status: 'pending' },
  { id: 'deploy-10', number: 10, description: 'Build Email Worker', category: 'backend', status: 'pending' },
  
  // Cloudflare Deployment
  { id: 'deploy-11', number: 11, description: 'Deploy API Worker', category: 'network', status: 'pending' },
  { id: 'deploy-12', number: 12, description: 'Deploy Files Worker', category: 'network', status: 'pending' },
  { id: 'deploy-13', number: 13, description: 'Deploy Email Worker', category: 'network', status: 'pending' },
  { id: 'deploy-14', number: 14, description: 'Deploy to Cloudflare Pages', category: 'network', status: 'pending' },
  { id: 'deploy-15', number: 15, description: 'Update DNS records', category: 'network', status: 'pending' },
  
  // Post-deployment
  { id: 'deploy-16', number: 16, description: 'Verify API endpoints', category: 'backend', status: 'pending' },
  { id: 'deploy-17', number: 17, description: 'Test authentication', category: 'backend', status: 'pending' },
  { id: 'deploy-18', number: 18, description: 'Test file uploads', category: 'storage', status: 'pending' },
  { id: 'deploy-19', number: 19, description: 'Monitor error rates', category: 'backend', status: 'pending' },
  { id: 'deploy-20', number: 20, description: 'Deployment complete', category: 'response', status: 'pending' },
];

// Function to simulate step execution
export const executeSteps = async (
  steps: Step[],
  onUpdate: (stepId: string, status: Step['status'], details?: string) => void,
  delay: number = 500
): Promise<void> => {
  for (const step of steps) {
    // Mark as running
    onUpdate(step.id, 'running', `Executing: ${step.description}`);
    
    // Simulate processing time
    await new Promise(resolve => setTimeout(resolve, delay));
    
    // Mark as success (with small chance of error for realism)
    const status = Math.random() > 0.95 ? 'error' : 'success';
    const details = status === 'error' 
      ? `Failed: ${step.description}` 
      : `Completed: ${step.description}`;
    
    onUpdate(step.id, status, details);
    
    // Stop if error
    if (status === 'error') {
      // Mark remaining as skipped
      const remainingSteps = steps.slice(steps.indexOf(step) + 1);
      remainingSteps.forEach(s => onUpdate(s.id, 'skipped', 'Skipped due to error'));
      break;
    }
  }
};

// Master list of all features and their steps
export const allFeatures = {
  authentication: {
    name: 'Authentication System',
    steps: authenticationSteps,
    estimatedTime: '12.5s',
    complexity: 'Medium'
  },
  userCrud: {
    name: 'User CRUD Operations',
    steps: userCrudSteps,
    estimatedTime: '11.5s',
    complexity: 'Low'
  },
  projectManagement: {
    name: 'Project Management',
    steps: projectManagementSteps,
    estimatedTime: '8s',
    complexity: 'Medium'
  },
  deployment: {
    name: 'Full Deployment Pipeline',
    steps: deploymentSteps,
    estimatedTime: '10s',
    complexity: 'High'
  },
  fileUpload: {
    name: 'File Upload to R2',
    steps: [
      { id: 'file-1', number: 1, description: "User clicks 'Choose File'", category: 'user' as const, status: 'pending' as const },
      { id: 'file-2', number: 2, description: 'File selected and shown in UI', category: 'frontend' as const, status: 'pending' as const },
      { id: 'file-3', number: 3, description: "User clicks 'Upload to R2'", category: 'user' as const, status: 'pending' as const },
      { id: 'file-4', number: 4, description: 'Validate file exists', category: 'frontend' as const, status: 'pending' as const },
      { id: 'file-5', number: 5, description: 'Check auth token exists', category: 'frontend' as const, status: 'pending' as const },
      { id: 'file-6', number: 6, description: 'Create FormData object', category: 'frontend' as const, status: 'pending' as const },
      { id: 'file-7', number: 7, description: 'Add file to FormData', category: 'frontend' as const, status: 'pending' as const },
      { id: 'file-8', number: 8, description: "Add 'public' flag to FormData", category: 'frontend' as const, status: 'pending' as const },
      { id: 'file-9', number: 9, description: 'Build upload URL', category: 'frontend' as const, status: 'pending' as const },
      { id: 'file-10', number: 10, description: 'Send POST request to Files Worker', category: 'network' as const, status: 'pending' as const },
      { id: 'file-11', number: 11, description: 'Files Worker receives request', category: 'backend' as const, status: 'pending' as const },
      { id: 'file-12', number: 12, description: 'Worker checks Authorization header', category: 'backend' as const, status: 'pending' as const },
      { id: 'file-13', number: 13, description: 'Worker decodes JWT token', category: 'backend' as const, status: 'pending' as const },
      { id: 'file-14', number: 14, description: 'Worker parses FormData', category: 'backend' as const, status: 'pending' as const },
      { id: 'file-15', number: 15, description: 'Worker uploads to R2', category: 'storage' as const, status: 'pending' as const },
    ] as Step[],
    estimatedTime: '7.5s',
    complexity: 'Medium'
  }
};

// Calculate total steps across all features
export const getTotalSteps = (): number => {
  return Object.values(allFeatures).reduce((total, feature) => total + feature.steps.length, 0);
};

// Get steps for a specific operation
export const getStepsForOperation = (operation: keyof typeof allFeatures): Step[] => {
  return allFeatures[operation]?.steps || [];
};